// `landingStep` = the step the phase bar jumps to when the user clicks a completed phase.
// Skips loader/transitional steps (discovering, finding) to preserve prospects/touches state without re-running LLM calls.
// `timeRemaining` = rough estimate shown top-right of the phase bar when this phase is current.
export const PHASES = [
  { key: 'design', label: 'Design', steps: ['design', 'q0', 'q1', 'q2'], landingStep: 'design', timeRemaining: 'about 3 min' },
  { key: 'wordsmith', label: 'Wordsmith', steps: ['discovering', 'messages'], landingStep: 'messages', timeRemaining: 'about 2 min' },
  { key: 'prospects', label: 'Prospects', steps: ['finding', 'prospects'], landingStep: 'prospects', timeRemaining: 'under a min' },
  { key: 'launch', label: 'Launch', steps: ['launched'], landingStep: 'launched', timeRemaining: '' },
];

export const COACH_PHASES = [
  { key: 'design', label: 'Design', steps: ['design', 'q0', 'q1', 'q2'], landingStep: 'design', timeRemaining: 'about 3 min' },
  { key: 'launch', label: 'Launch', steps: ['launched'], landingStep: 'launched', timeRemaining: '' },
];
